
<div class="row">
  <TextField
    v-model="activity.subject"
    name="subject"
    :label="__('common.subject')"
    class="col-md-7"
    required
  />

  <SelectField
    v-model="activity.priority"
    name="priority"
    :label="__('common.priority')"
    class="col-md-2"
    required
    :options="ActivityModel.priorities()"
  />

  <SelectField
    v-model="activity.type"
    name="type"
    :label="__('activities.form-activity-type')"
    class="col-md-3"
    required
    :options="ActivityModel.types()"
  />

  <TextAreaField
    v-model="activity.description"
    name="description"
    class="col-md-9"
    :label="__('common.description')"
    :rows="10"
  />

  <b-col md="3">
    <DateField
      v-model="activity.activityDate"
      name="activity_date"
      :label="__('activities.form-activity-date')"
      required
    />

    <SelectField
      v-model="activity.entityId"
      name="entity_id"
      :label="__('common.entity')"
      required
      :first-by-default="true"
      :options="activityEntities"
      @onChange="getActivityEntityResponsibleUsers"
    />

    <SelectField
      v-model="activity.userId"
      name="user_id"
      first-by-default
      :label="__('common.responsible')"
      required
      :options="activityUsers"
    />
  </b-col>

  <FormActions cols="12" :on-submit="save" :on-cancel="cancel" />
</div>
